import React, { useEffect, useState, useRef, useCallback } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import GalleryElement from "./galleryElement/GalleryElement";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import BlogRequests from "../../assets/services/blog";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../assets/containers/loadingDialog";

const Gallery = () => {
  const dispatch = useDispatch();
  const { gallery, fetchBlogsLoading, galleryTotalPages } = useSelector(
    ({ blog }) => blog
  );

  const [page, setPage] = useState(1);
  const observer = useRef();

  useEffect(() => {
    dispatch(BlogRequests.getGalleryMedia(1, 3));
  }, [dispatch]);

  useEffect(() => {
    if (page === 1) return;
    const fetchMoreData = async () => {
      dispatch(BlogRequests.getGalleryMedia(page, 3));
    };
    fetchMoreData();
  }, [page, dispatch]);

  const lastElementRef = useCallback(
    (node) => {
      // if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < galleryTotalPages) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [page, galleryTotalPages]
  );

  const galleryElements = gallery.map((media, index) => {
    return (
      <GalleryElement
        ref={index === gallery.length - 1 ? lastElementRef : null}
        key={index}
        category={media.name}
        date={media.eventDate}
        media={media.files}
      />
    );
  });

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {fetchBlogsLoading && page === 1 ? (
          <Loading
            className={"w-100 d-flex justify-content-center my-5 py-5"}
          />
        ) : gallery && gallery.length !== 0 ? (
          <>
            {galleryElements}
            {fetchBlogsLoading && (
              <Loading
                className={"w-100 d-flex justify-content-center my-5 py-5"}
              />
            )}
          </>
        ) : (
          <NoResultAlter className={"w-100 py-5 my-5"} />
        )}
      </div>
    </AnimatedPageContainer>
  );
};

export default Gallery;
